import React from 'react'
import FormTest from './formTest';
import FormFinal from './formFinal';

import Control from '../store/control';
import FinalDeviceFinalStep from './formFinalDeviceFinalStep';

/**
 * Renders a form based on the selected type.
 * And for now, test socket and final socket are the same, but only some modeling parameters are different.
 * @returns {JSX.Element|null} The form component to render or null if no type is selected.
 */
const SideForm = () => {
  const type     = Control.Get('type');

  switch(type) {
    case 'TestSocket':
      return <FormTest/>;
    case 'FinalDevice':
      return <FormTest/>;
    case 'FinalDeviceFinalStep':
      return <FinalDeviceFinalStep/>;
    default:
      return null;
  }
}

export default SideForm;
